<template>
  <div class="homeleft">
    <div class="listai">
      <h1>
        《起名废急救指南》第二章 第一节 姓氏文化简介
      </h1>
      <Row justify="center" class="titleTime">
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">作者：姓名图谱官方</Col>
        <Col class="titleName" :xs="12" :sm="12" :md="12" :lg="12">时间：2020年1月6日</Col>
      </Row>
      <p></p>
      <h3 style="text-align:center;">一、姓氏起源和发展</h3>
      <p></p>
      <p>“姓”的本义是源于同一女性始祖，具有共同血缘关系的部族所共有的符号。氏是姓的分支，夏商之前就有少量的氏产生，到了周朝则大量产生，主要用于彰显功德。此时，贵族都是既有姓也既有氏的，而且同姓不通婚。据统计《春秋》中有风，妫，姬，姒，子，嬴，己，任，姞，祁，芈，曹，妘，董，姜，偃，归，曼，熊，隗，漆，允等22个姓，当今的很多姓都是从这些姓演变而来。周代实行宗法制，有大、小宗之别。一个氏的建立表示一个小宗从大宗（氏）分裂出来，另立门户。建立侯国要经周王认可，卿大夫立新家要得到君主允许，称之为“胙之土而命之氏”。贵族获得氏的方式有以下几种：</p>
      <p></p>
      <h4>①以国名为氏。</h4>
      <p>诸侯国君主以受封的国名为氏。如晋重即晋文公重耳，以国名晋为氏，重为重耳的简称；鲁申即鲁僖公申，国名鲁为氏，申为名。</p>
      <h4>②以邑名为氏。</h4>
      <p>卿大夫及其子孙以采邑名为氏。如晋国大夫毕万采地为魏，后世子孙以魏为氏；曲沃桓叔之子公子万封于韩，以韩为氏。</p>
      <h4>③以官名为氏。</h4>
      <p>贵族及其子孙以其官名为氏。晋国的林父为步兵组织三行里中行的军帅，称中行桓子，其子荀偃称中行偃，以中行为氏；宋国执政卿乐喜（子罕）称司城子罕，其孙乐祁（子梁）称司城氏，是以司城为氏。</p>
      <h4>④以职业名为氏。</h4>
      <p>如巫氏、卜氏、匠氏、陶氏，巫、卜、匠、陶皆为职业名称。</p>
      <h4>⑤以住地之名为氏。</h4>
      <p>鲁庄公子遂住鲁东门，称东门遂（名）、东门襄仲（字），是以东门为氏；宋国乐大心为右师，居于宋桐门，称桐门右师，是以桐门为氏。</p>
      <h4>⑥以同周王或侯君主血缘关系远近之称为氏。</h4>
      <p>周僖王之子虎称王子虎，其孙称王孙苏；郑穆公之子喜（子罕）称公子喜，其孙舍之（子展）称公孙舍之。</p>
      <h4>⑦ 以贵族的字为氏</h4>
      <p>按照宗法制度，公族只包括各代国君的近亲三代，公孙之子不属公族而须另外立氏。这些贵子孙多以其王父（祖父）之字为其氏。郑国公子发字子国，其孙国参（子思）即以“子国”的末字为氏；另有公子騑，字子驷，其孙以“驷”为氏。以祖父之字为氏最为常见，是得氏通例。</p>
      <p style="font-weight:600;">春秋战国时，宗法制度瓦解，姓氏制度也发生根本变革，这时氏开始转变为姓。以往贵族才有姓氏，平民仅有名，战国以后，平民有姓，百姓遂成为民众的通称。秦统一六国后，姓氏逐渐合一。</p>
      <div class="contentImg">
        <img src="@/assets/shu.jpg" />
      </div>
      <div class="contentImg">
        <img src="@/assets/huangdi.jpg" />
      </div>
      <h4>那么，我国到底有多少个姓氏呢？</h4>
      <p>北宋编撰、流传最广的《百家姓》，仅收录438个姓；明代编纂的《千家姓》，共收录1968个姓；而据《中华姓氏大辞典》记载，目前中国56个民族的姓已达11969个；窦学田所编《中华古今姓氏大辞典》中收录的古今姓氏更多达12000个；</p>
      <p>据2019.1公安部发布的统计显示，目前全国在用姓氏共计6150个。传统意义上的“百家姓”，占全国户籍人口总量的近85%。</p>
      <div class="contentImg">
        <img src="@/assets/xing.jpg" />
      </div>
      <p>全国共有23个姓氏户籍人口数量超过一千万。王姓、李姓户籍人口数量均超过1亿。</p>
      <div class="contentImg">
        <img src="@/assets/renkou.jpg" />
      </div>
      <p>对于这些大姓，我们在前一篇已经介绍了，重名很难避免，因此这些大姓的家长要格外注意这个问题。</p>
      <h3 style="text-align:center;">二、 姓氏的特点</h3>
      <p>以下内容部分参考王泉根教授的《中国人姓名的奥秘》和互联网数据整理。</p>
      <div class="contentImg">
        <img src="@/assets/biao.jpg" />
      </div>
      <p>这些姓氏特点，在取名时可以参考，因为有一种取名方法是将姓和名联系起来，此时姓的具体含义也会参与到整个名字的构词中。</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: []
    };
  }
};
</script>

<style scoped lang="scss">
.homeleft {
  .listai {
    .contentImg {
      text-align: center;
      img {
        width: 600px;
      }
      @media screen and(max-width:1200px) {
        img {
          width: 300px;
        }
      }
    }
    @media screen and(max-width:1200px) {
      padding: 0px;
    }
    padding: 16px;
    h1 {
      margin: 30px 0;
      text-align: center;
      @media screen and(max-width:1200px) {
        margin: 10px 0;
      }
    }
    h3 {
      color: #00d2a5;
      // text-align: center;
    }
    h4 {
      font-size: 16px;
      // text-indent: 8px;
    }
    h5 {
      font-size: 15px;
       text-indent: 14px;
    }
    .titleTime {
      height: 80px;
      line-height: 80px;
      border-bottom: 1px #e8eaec solid;
      .titleName {
        color: #00d2a5;
        text-align: center;
      }
    }
    p {
      @media screen and(max-width:1200px) {
        padding: 5px;
      }
      padding: 10px 20px;
      font-size: 15px;
      text-indent: 28px;
      line-height: 28px;
    }
  }
}
</style>
